export default {
	sec_10: {
		title: {
			one: 'JP WORLD Pay',
			two: '独自口座システム',
		},
		desc: {
			one: '銀行にのみ口座があるのではありません。',
			two: 'JP WORLD PAY 提供口座で、より便利に',
		},
		btn: {
			one: '会員登録',
			two: 'アプリダウンロード',
		},
	},
	sec_13: {
		title: {
			one: '口座システムで早い送金',
			two: 'JP WORLD Pay ',
			three: '今体験してみてください。',
		},
		features: {
			one: {
				title: {
					one: '独自口座システムで',
					two: 'より早く',
				},
				description: {
					one: 'JP WORLD PAYからJP WORLD PAY口座に送金時1~3秒内に送金が可能になりました。',
					two: 'もう待つ必要がありません。',
				},
			},
			two: {
				title: {
					one: '送金システム',
					two: 'を作る',
				},
				description: {
					one: '口座を利用したJP WORLD PAYからJP WORLD PAYに送金時',
					two: '手数料無料、時間短縮が可能',
				},
			},
		},
	},
};
